/*eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/vendor";

export function getAll() {
  return APIClient.get(`${endpoint}`);
}

export function getAllRole() {
  return APIClient.get(`/Role`);
}

export function getOne() {
  return APIClient.get(`${endpoint}`);
}

export function remove(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}

export function create(value) {
  return APIClient.post(`${endpoint}`, value);
}

export function edit(values) {
  return APIClient.put(`${endpoint}/${values.id}`, values.data);
}
